<script>
export default {
  name: 'SkeletonAvatar',
  props: {
    avatar: {
      type: Object,
      default: null
    }
  },

  render(h) {
    let data = {
      class: {
        'skeleton-avatar': true,
        'skeleton-avatar-lg': this.avatar && this.avatar.size && this.avatar.size.indexOf('large') > -1,
        'skeleton-avatar-sm': this.avatar && this.avatar.size && this.avatar.size.indexOf('small') > -1,
        'skeleton-avatar-square': this.avatar && this.avatar.shape && this.avatar.shape.indexOf('square') > -1,
        'skeleton-avatar-circle': this.avatar && this.avatar.shape && this.avatar.shape.indexOf('circle') > -1
      }
    }
    return h('div', {
      class: {
        'skeleton-header': true
      }
    }, [
      h('span', data)
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/module/skeleton/avatar.vue